module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<select class=\"w100\" data-column=\"")
    ; __append(escapeFn( column.name ))
    ; __append("\" on-change=\"onEnumColumnChange\">\n	")
    ;  if (column.showEmpty) { 
    ; __append("\n	<option value=\"\"></option>\n	")
    ;  } 
    ; __append("\n	")
    ;  column.enum.each(function (value) { 
    ; __append("\n	<option value=\"")
    ; __append(escapeFn( value ))
    ; __append("\" ")
    ; __append(escapeFn( value == widget.item[column.name] ? "selected" : ""))
    ; __append(">")
    ; __append(escapeFn( column.enum.title(value) ))
    ; __append("</option>\n	")
    ;  }) 
    ; __append("\n</select>")
  }
  return __output.join("");

}